import { useContext } from "react";
import { AuthContext } from "../auth/AuthContext";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export function useCreateEvent() {
  const { accessToken } = useContext(AuthContext);

  const createEvent = async (payload) => {
    const formData = new FormData();
    for (const [key, value] of Object.entries(payload)) {
      if (key === "categories" && Array.isArray(value)) {
        value.forEach(v => formData.append("categories", v));  // 🔥 ← to jest poprawne
      } else if (value !== null && value !== undefined && value !== "") {
        formData.append(key, value);
      }
    }

    console.log("Form data:",[...formData.entries()]);

    try {
      const res = await fetch(`${API_BASE}/api/events/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
        body: formData,
      });

      const data = await res.json();
      console.log("Backend response",data);

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        return { success: false, message: err.detail || "Błąd serwera" };
      }

      return { success: true };
      
    } catch {
      return { success: false, message: "Brak połączenia z serwerem" };
    }
  };

  return { createEvent };
}
